import script from "./AccommodationMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccommodationMap.vue?vue&type=script&setup=true&lang=ts"

import "./AccommodationMap.vue?vue&type=style&index=0&id=ad1cb360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1cb360"]])

export default __exports__